<template>
  <div>
    <v-card>
      <v-card-title class="headline">
        <a
          :href="urlCRMBitrix(ticket.Id)"
          target="_blank"
        >Ticket {{ ticket.TicketCode }}</a>
        <v-spacer></v-spacer>
        <v-btn
          round
          color="success"
          dark
          v-if="ticket.IsCanDispatch"
          @click="dispatch()"
        >Điều phối</v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-card-title primary-title>Overview</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 class="text">
                <v-icon>directions_car</v-icon>
                Vehicle: {{ ticket.Vehicle }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>code</v-icon>
                Ticket Code: {{ ticket.TicketCode }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>location_on</v-icon>
                TrackingID: {{ ticket.TrackingIds }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>build</v-icon>
                Status: {{ ticket.Status }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>label_important</v-icon>
                Type: {{ ticket.Type }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>description</v-icon>
                Description: {{ ticket.Description }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>&nbsp;
        <v-card>
          <v-card-title primary-title>Repair</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 class="text">
                <v-icon>contacts</v-icon>
                Driver Contact: {{ ticket.DriverContact }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>person</v-icon>
                Repair Person: {{ ticket.RepairPersons }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>location_on</v-icon>
                Repair Location: {{ ticket.RepairLocation }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>location_on</v-icon>Location:
                <a
                  :href="`https://www.google.com/maps?q=${ticket.Location}`"
                  target="_blank"
                >{{ ticket.Location}}</a>
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>access_time</v-icon>
                Installation Time Expected: {{ ticket.InstallationTimeExpected }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>access_time</v-icon>
                Installation Duration: {{ ticket.InstallationDuration }} (minutes)
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>date_range</v-icon>
                Plan: {{ ticket.PlanTime}}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>date_range</v-icon>
                Finished: {{ ticket.FinishedTime}}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>error</v-icon>
                Error Type: {{ ticket.ErrorType }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>attach_money</v-icon>
                Repair Cost: {{ ticket.RepairCost }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>attach_money</v-icon>
                Customer Charge: {{ ticket.CustomerCharge }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>phone_android</v-icon>
                Last Viewed (By phone): {{ ticket.LastViewedByPhone }}
              </v-flex>
              <v-flex xs12 class="text">
                <v-icon>history</v-icon>
                WorkLog: {{ ticket.WorkLog }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>&nbsp;
        <v-card>
          <v-card-title primary-title>Other</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 class="text">
                <v-icon>person</v-icon>
                Created By: {{ ticket.CreatedBy }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>date_range</v-icon>
                Created: {{ ticket.CreatedTime }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>person</v-icon>
                Modified By Name: {{ ticket.ModifiedByName }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>date_range</v-icon>
                Date Modified: {{ ticket.DateModified }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>person</v-icon>
                Assigned To: {{ ticket.AssignedUser }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
    <!-- Dialog -->
    <div class="text-xs-center">
      <v-dialog v-model="isDispatching" fullscreen lazy scrollable>
        <v-card>
          <div v-if="isDispatching">
            <overview
              :selectedCase="ticket"
              :supporters="supporters"
              @display="hideDispatch($event)"
            />
          </div>
        </v-card>
      </v-dialog>
    </div>
    <!-- End Dialog -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Overview from '@/pages/dispatch/Overview';
import moment from 'moment';
import { formatGMTToLocalTime } from '@/utils/datetime';
import { urlCRMBitrix } from '@/utils/index';

export default {
  components: {
    Overview
  },
  props: {
    ticket: Object,
    isTicket: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isDispatching: false,
      moment: moment,
      userCanDispatch: [
        'trinm@vietmap.vn',
        'trivm@vietmap.vn',
        'thuongnh@vietmap.vn',
        'trinhtp@vietmap.vn',
        'nguyendt@vietmap.vn',
        'vinhlc@vietmap.vn',
        'luantv@vietmap.vn',
        'nhungtt@vietmap.vn',
        'thiennh@vietmap.vn',
        'thanhhh@vietmap.vn',
        'anhtq@vietmap.vn',
        'diendt@vietmap.vn',
      ]
    };
  },
  computed: {
    ...mapGetters(['supporters', 'loggedUser'])
  },
  methods: {
    formatGMTToLocalTime,
    urlCRMBitrix,
    ...mapMutations(['SET_SELECTED_CASES']),
    dispatch () {
      let caseDetail = { ...this.ticket };
      caseDetail.CaseNumber = this.ticket.TicketCode; // Đồng bộ với overview
      this.SET_SELECTED_CASES(caseDetail);
      this.isDispatching = true;
    },
    hideDispatch (isShow) {
      this.isDispatching = isShow;
      this.$emit('display', false);
    }
  }
};
</script>
<style scoped>
.v-icon {
  padding-right: 24px;
  font-size: 16pt;
  padding-left: 24px;
}
.work-log {
  line-height: 24pt !important;
}
.text {
  padding-bottom: 8px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/crm/TicketDetail.vue